import { BillingModel, BillingInterval } from '@graphql';
import * as Yup from 'yup';

export const makeValidationSchema = (minSeats: number) =>
  Yup.object().shape({
    currentTierId: Yup.string().required('Organization Plan is required.'),

    purchasedSeats: Yup.number()
      .required('N° of Seats is required.')
      .integer('N° of Seats must be an integer.')
      .min(minSeats, `N° of Seats must be at least ${minSeats}.`),

    billingModel: Yup.mixed<BillingModel>()
      .oneOf(Object.values(BillingModel))
      .required('Payment Method is required.'),

    billingInterval: Yup.string().when('billingModel', {
      is: BillingModel.CREDIT_CARD,
      then: (schema) =>
        schema.oneOf(Object.values(BillingInterval)).required('Payment Frequency is required.'),
      otherwise: (schema) => schema.notRequired(),
    }),

    startDate: Yup.string().when('billingModel', {
      is: BillingModel.INVOICE,
      then: (schema) => schema.required('Start date is required for Invoice billing.'),
      otherwise: (schema) => schema.notRequired(),
    }),

    endDate: Yup.string()
      .when('billingModel', {
        is: BillingModel.INVOICE,
        then: (schema) => schema.required('End date is required for Invoice billing.'),
        otherwise: (schema) => schema.notRequired(),
      })
      .when('startDate', (startDate, schema) => {
        if (!startDate) return schema;
        return schema.test(
          'is-after-start',
          'End date must be after start date.',
          (value: string | undefined) => {
            if (!value) return true;
            const start = Array.isArray(startDate) ? startDate[0] : startDate ?? '';
            return new Date(value) >= new Date(start);
          },
        );
      }),

    trialPeriodDays: Yup.number()
      .nullable()
      .transform((value) =>
        value === '' || value === null || value === undefined ? null : Number(value),
      )
      .integer('Trial Period Days must be an integer.')
      .min(0, 'Trial Period Days must be at least 0.')
      .max(365, 'Trial Period Days must be at most 365.'),
  });
